import { ProductState } from "./../../products/components/ProductsTable";
import * as z from "zod";

export const replenishmentSchema = z.object({
  supplierRut: z
    .string()
    .min(12, { message: "El rut debe ser valido" })
    .max(12, { message: "El rut debe ser valido" }),
  invoiceNumber: z
    .string()
    .min(1, { message: "El número de factura debe ser valido" }),
  storageId: z.string().min(1, { message: "El almacen debe ser valido" }),
  zoneId: z.string().min(1, { message: "La zona debe ser valida" }),
  // array of ProductState
  products: z.custom<ProductState[]>(),
});

export type ReplenishmentFormInput = z.infer<typeof replenishmentSchema>;
